const API_OPERATIONS = {
  CUSTOMER_LIST: { path: "/customers", method: "GET" },
  CUSTOMER_CREATE: { path: "/customers", method: "POST" },
  CUSTOMER_UPDATE: { path: "/customers/:id", method: "PUT" },
  CUSTOMER_DELETE: { path: "/customers/:id", method: "DELETE" },

  LICENCE_LIST: { path: "/licences", method: "GET" },
  LICENCE_GET_PEM: { path: "/licences/:id/pem", method: "GET" },
  LICENCE_SEND_EMAIL: { path: "/licences/:id/email", method: "GET" },
  LICENCE_CREATE: { path: "/licences", method: "POST" },
  LICENCE_DELETE: { path: "/licences/:id", method: "DELETE" },
  // LICENCE_TAG: { path: "/licences/:id/tag", method: "PUT" },

  ROLE_LIST: { path: "/roles", method: "GET" },
  ROLE_ASSIGNMENTS: { path: "/role_assignments", method: "GET" },
  ROLE_ASSIGN: { path: "/roles/:roleName/users/:userId", method: "PUT" },

  TAGS_LIST: { path: "/tags", method: "GET" },

  LICENSOR_LIST: { path: "/licensors", method: "GET" },
  LICENSOR_CREATE: { path: "/licensors", method: "POST" },
  LICENSOR_UPDATE: { path: "/licensors/:id", method: "PUT" },
  LICENSOR_UPDATE_PASSWORD: { path: "/licensors/:id/password", method: "PUT" },
  LICENSOR_UPDATE_ENABLED: { path: "/licensors/:id/enabled", method: "PUT" },
  LICENSOR_DELETE: { path: "/licensors/:id", method: "DELETE" },

  PARTNER_LIST: { path: "/partners", method: "GET" },
  PARTNER_CREATE: { path: "/partners", method: "POST" },
  PARTNER_UPDATE: { path: "/partners/:id", method: "PUT" },
  PARTNER_DELETE: { path: "/partners/:id", method: "DELETE" },
};

const ADMIN_LICENSOR_RESTRICTIONS: Array<keyof typeof API_OPERATIONS> = [];

const PARTNER_RESTRICTIONS: Array<keyof typeof API_OPERATIONS> = [
  "CUSTOMER_DELETE",
  "LICENCE_DELETE",
  "PARTNER_LIST",
  "PARTNER_CREATE",
  "PARTNER_UPDATE",
  "PARTNER_DELETE",
];

const LICENSOR_RESTRICTIONS: Array<keyof typeof API_OPERATIONS> = [
  ...PARTNER_RESTRICTIONS,
  "LICENSOR_LIST",
  "LICENSOR_CREATE",
  "LICENSOR_UPDATE",
  "LICENSOR_DELETE",
  "LICENSOR_UPDATE_ENABLED",
];

const ROLES = {
  ADMIN: "admin",
  ADMIN_LICENSOR: "admin_licensor",
  LICENSOR: "licensor",
  PARTNER: "partner",
};

const getAllowedOperations = (
  restrictions: Array<keyof typeof API_OPERATIONS>,
): Array<{ path: string; method: string }> =>
  Object.keys(API_OPERATIONS)
    .filter(
      opName => !restrictions.includes(opName as keyof typeof API_OPERATIONS),
    )
    .map(
      filteredOpName =>
        API_OPERATIONS[filteredOpName as keyof typeof API_OPERATIONS],
    );

const ROLE_PERMISSIONS: {
  [key: string]: Array<{ path: string; method: string }>;
} = {
  [ROLES.ADMIN]: getAllowedOperations([]),
  [ROLES.ADMIN_LICENSOR]: getAllowedOperations(ADMIN_LICENSOR_RESTRICTIONS),
  [ROLES.LICENSOR]: getAllowedOperations(LICENSOR_RESTRICTIONS),
  [ROLES.PARTNER]: getAllowedOperations(PARTNER_RESTRICTIONS),
};

const canPerformOperation = (roles: string[], path: string, method: string) =>
  roles.some(role => {
    if (!ROLE_PERMISSIONS[role]) {
      return false;
    }
    return ROLE_PERMISSIONS[role].some(
      operation =>
        operation.path === path && operation.method.toLowerCase() === method,
    );
  });

const PARTNER_ROLES = [ROLES.PARTNER, ROLES.LICENSOR];
const ADMIN_ROLES = [ROLES.ADMIN, ROLES.ADMIN_LICENSOR];
const ADMIN_PARTNER_ROLES = [ROLES.ADMIN, ROLES.PARTNER];

export default {
  canPerformOperation,
  ROLES_LIST: Object.values(ROLES),
  ROLES_MAP: ROLES,
  PARTNER_ROLES,
  ADMIN_ROLES,
  ADMIN_PARTNER_ROLES,
};
